import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { initInputField } from '../../../../../orientations/helpers/helpers';

const initState = {
  isLoading: false,
  editForm: {
    agencies: initInputField('agencies'),
  },
  total: 0,
};

function validate(_attr, _value) {
  const error = '';

  return error;
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onUpdateAgenciesRequest(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onUpdateAgenciesSuccess(state) {
  return {
    ...state,
    isLoading: false,
  };
}

function onUpdateAgenciesError(state) {
  return {
    ...state,
    isLoading: false,
  };
}

function updateValueWithAgencies(state, { payload }) {
  const { editForm } = state;
  const { agencies } = payload;

  const agenciesIds = agencies.reduce((ids, { id, required }) => {
    if (required) {
      ids.push(id);
    }

    return ids;
  }, []);

  editForm.agencies.value = agenciesIds;

  return {
    ...state,
    isLoading: false,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.UPDATE_AGENCIES_REQUEST]: onUpdateAgenciesRequest,
  [actions.UPDATE_AGENCIES_SUCCESS]: onUpdateAgenciesSuccess,
  [actions.UPDATE_AGENCIES_ERROR]: onUpdateAgenciesError,
  [actions.UPDATE_AGENCIES_VALUE]: updateValueWithAgencies,
});
